import React, { Component } from "react";
// import FontAwesome from 'react-fontawesome';
import firebase from "firebase";
import { history } from "../store";

import "./SignUp.css";

class SignUp extends Component {
  constructor() {
    super();

    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      cellPhone: "",
      birthday: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: ""
    };

    this.createUser = this.createUser.bind(this);
    this.firstNameChanged = this.firstNameChanged.bind(this);
    this.lastNameChanged = this.lastNameChanged.bind(this);
    this.emailChanged = this.emailChanged.bind(this);
    this.passwordChanged = this.passwordChanged.bind(this);
    this.cellPhoneChanged = this.cellPhoneChanged.bind(this);
    this.birthdayChanged = this.birthdayChanged.bind(this);
    this.address1Changed = this.address1Changed.bind(this);
    this.address2Changed = this.address2Changed.bind(this);
    this.cityChanged = this.cityChanged.bind(this);
    this.stateChanged = this.stateChanged.bind(this);
    this.zipChanged = this.zipChanged.bind(this);
    this.onPlaceChanged = this.onPlaceChanged.bind(this);
  }

  componentWillMount() {
    // TODO: hit Firebase via "masterkey" to lookup requestor name
    // this.setState({requestorFirstName: 'Shahab'});
    // this.setState({requestorFullName: 'Shahab Lashkari'});
  }

  componentDidMount() {
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.refs.addressInput,
      {
        types: ["address"]
      }
    );

    this.autocomplete.addListener("place_changed", this.onPlaceChanged);
  }

  onPlaceChanged() {
    const place = this.autocomplete.getPlace();
    if (place.address_components) {
      // Hacked together from: https://github.com/alanrsoares/react-address-lookup/blob/master/AddressLookup.js
      // TODO: Clean this up!
      const camelize = s => s.replace(/_./g, ([_, x]) => x.toUpperCase());
      const camelizeKeys = o =>
        Object.keys(o).reduce(
          (acc, k) => ({ ...acc, [camelize(k)]: o[k] }),
          {}
        );
      const type = ({ types }) => types[0];
      const reducer = (acc, component, i) => ({
        ...acc,
        [camelize(type(component))]: camelizeKeys(component)
      });
      const result = place.address_components.reduce(reducer, {});
      // console.log(result);
      const {
        streetNumber: number,
        route: street,
        locality: city,
        administrativeAreaLevel1: state,
        postalCode: zip
      } = result;
      // console.log(place.address_components);
      //const [{long_name : number}, {long_name : street}, {long_name : city}, {long_name : county}, {short_name : state}, {long_name : country}, {long_name : zip}] = place.address_components;
      // console.log(number,street,city,state,zip);
      this.setState({
        address1: `${number.longName} ${street.longName}`,
        city: city.longName,
        state: state.shortName,
        zip: zip.longName
      });
    }
  }

  createUser(event) {
    event.preventDefault();

    const newUser = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      password: this.state.password,
      cellPhone: this.state.cellPhone,
      birthday: this.state.birthday,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip
    };

    if (
      newUser.firstName &&
      newUser.lastName &&
      newUser.email &&
      newUser.password
    ) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(newUser.email, newUser.password)
        .catch(error => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error(`Error ${errorCode} (creating user): ${errorMessage}`);
        })
        .then(user => {
          user
            .updateProfile({
              displayName: `${this.state.firstName} ${this.state.lastName}`
            })
            .then(() => {
              user.sendEmailVerification();
            });
          firebase
            .database()
            .ref("Users/" + user.uid)
            .set({
              firstName: newUser.firstName,
              lastName: newUser.lastName,
              email: newUser.email,
              cellPhone: newUser.cellPhone,
              birthday: newUser.birthday,
              address1: newUser.address1,
              address2: newUser.address2,
              city: newUser.city,
              state: newUser.state,
              zip: newUser.zip
            })
            .catch(error => {
              const errorCode = error.code;
              const errorMessage = error.message;
              console.error(
                `Error ${errorCode} (adding user to DB): ${errorMessage}`
              );
            })
            .then(() => {
              console.log("User created successfully!");
              history.push("/");
            });
        });
    }
  }

  firstNameChanged(event) {
    this.setState({ firstName: event.target.value });
  }

  lastNameChanged(event) {
    this.setState({ lastName: event.target.value });
  }

  emailChanged(event) {
    this.setState({ email: event.target.value });
  }

  passwordChanged(event) {
    this.setState({ password: event.target.value });
  }

  cellPhoneChanged(event) {
    this.setState({ cellPhone: event.target.value });
  }

  birthdayChanged(event) {
    this.setState({ cellPhone: event.target.value });
  }

  address1Changed(event) {
    event.preventDefault();
    this.setState({ address1: event.target.value });
  }

  address2Changed(event) {
    this.setState({ address2: event.target.value });
  }

  cityChanged(event) {
    this.setState({ city: event.target.value });
  }

  stateChanged(event) {
    if (event.target.value) {
      this.setState({ state: event.target.value });
    }
  }

  zipChanged(event) {
    this.setState({ zip: event.target.value });
  }

  render() {
    return (
      <section id="signup-contact-view" className="card">
        <p>
          You're just 2 steps away from an updated address book! Just fill out
          the form below to create an account. Once you're logged in, you'll get
          your own custom link that you can send to others to start collecting
          their contact information.
        </p>
        <p>
          Your personal information, as well as the contact info that others
          share with you, is always private and is not shared with anyone
          without your permission.
        </p>
        <form onSubmit={this.createUser}>
          <div className="sm-flex-col md-flex-row">
            <div className="form-group">
              <label htmlFor="signup-first-name" className="required">
                First Name
              </label>
              <input
                id="signup-first-name"
                type="text"
                className="form-control"
                placeholder="First Name"
                required
                value={this.state.firstName}
                onChange={this.firstNameChanged}
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-last-name" className="required">
                Last Name
              </label>
              <input
                id="signup-last-name"
                type="text"
                className="form-control"
                placeholder="Last Name"
                required
                value={this.state.lastName}
                onChange={this.lastNameChanged}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="signup-email" className="required">
              Email
            </label>
            {/* TODO: convert this to a component */}
            <input
              id="signup-email"
              type="text"
              className="form-control"
              placeholder="Email"
              value={this.state.email}
              onChange={this.emailChanged}
            />
          </div>
          <div className="form-group">
            <label htmlFor="signup-password" className="required">
              Password
            </label>
            {/* TODO: convert this to a component */}
            <input
              id="signup-password"
              type="password"
              className="form-control"
              placeholder="Password"
              value={this.state.password}
              onChange={this.passwordChanged}
            />
          </div>
          <br />
          <p>
            The below fields are all optional, and will only be used in the
            future if you'd like to share your contact info back to others. But
            don't worry, your contact information will not be shared with anyone
            without your express permission.
          </p>
          <br />
          <div className="sm-flex-col md-flex-row">
            <div className="form-group">
              <label htmlFor="signup-cell-phone">Cell Phone</label>
              {/* TODO: convert this to a component */}
              <input
                id="signup-cell-phone"
                type="text"
                className="form-control"
                placeholder="Cell Phone"
                value={this.state.cellPhone}
                onChange={this.cellPhoneChanged}
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-birthday">Birthday</label>
              {/* TODO: convert this to a component */}
              <input
                id="signup-birthday"
                type="date"
                className="form-control"
                placeholder="MM/DD/YYYY"
                value={this.state.birthday}
                onChange={this.birthdayChanged}
              />
            </div>
          </div>
          <div className="form-group">
            {/* TODO: use address validation API to fill in the rest? */}
            <label htmlFor="signup-address1">Street Address</label>
            <input
              id="signup-address1"
              ref="addressInput"
              type="text"
              className="form-control"
              placeholder="Street Address"
              value={this.state.address1}
              onChange={this.address1Changed}
            />
          </div>
          <div className="form-group">
            <label htmlFor="signup-address2">Address Line 2</label>
            <input
              id="signup-address2"
              type="text"
              className="form-control"
              placeholder="e.g., Apartment #105"
              value={this.state.address2}
              onChange={this.address2Changed}
            />
          </div>
          <div className="sm-flex-col md-flex-row">
            <div className="form-group">
              <label htmlFor="signup-city">City</label>
              <input
                id="signup-city"
                type="text"
                className="form-control"
                placeholder="City"
                value={this.state.city}
                onChange={this.cityChanged}
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-state">State</label>
              {/* TODO: convert this to a component */}
              <select
                id="signup-state"
                className="form-control"
                value={this.state.state}
                onChange={this.stateChanged}
              >
                <option value="" disabled>
                  Select your state...
                </option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AS">American Samoa</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FM">Federated States Of Micronesia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="GU">Guam</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MH">Marshall Islands</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PW">Palau</option>
                <option value="PA">Pennsylvania</option>
                <option value="PR">Puerto Rico</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VI">Virgin Islands</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="signup-zip">ZIP Code</label>
              <input
                id="signup-zip"
                type="text"
                className="form-control"
                placeholder="ZIP Code"
                value={this.state.zip}
                onChange={this.zipChanged}
              />
            </div>
          </div>
          <div className="footer-toolbar">
            <div className="toolbar">
              <button
                className="btn btn-secondary ml-auto"
                onClick={e => {
                  e.preventDefault();
                  history.push("/");
                }}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Sign Up
              </button>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp.js